import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { useLocation } from 'react-router'

import history from 'utils/history'

import { Assessment, FindInPage, Help, Home, CoPresent } from '@mui/icons-material'

import { Modal } from 'components'
import HelpDialog from 'components/ManualAnalysisList/HelpDialog'
import { AuthStates, decodeToken, getUserTokenStateFromDecoded, Scopes } from 'utils/authUtils'
import Container from './styles'
import NavigationItem from './NavigationItem'

const Navigation = () => {
  const location = useLocation()
  const token = useSelector((state) => state.auth.access_token)
  const [value, setValue] = useState(location.pathname)
  const [helpModalOpen, setHelpModalOpen] = useState(false)
  const decodedToken = decodeToken(token)
  const canListUserActivity = getUserTokenStateFromDecoded(decodedToken, [Scopes.USER_ACTIVITY_LIST_LOGS]) === AuthStates.AUTHORIZED
  const canShowStatistics = getUserTokenStateFromDecoded(decodedToken, [Scopes.APPLICATION_STATS]) === AuthStates.AUTHORIZED
  const canShowManualAnalysis = getUserTokenStateFromDecoded(decodedToken, [Scopes.REVIEW_LIST]) === AuthStates.AUTHORIZED
  const canShowApplications = getUserTokenStateFromDecoded(decodedToken, [Scopes.APPLICATION_LIST]) === AuthStates.AUTHORIZED

  const handleOnClick = (event) => {
    const route = event.target.getAttribute('data')
    if (route && route !== value) {
      setValue(route)
      history.push(route)
      history.go()
    }
  }

  useEffect(() => {
    if (value !== location.pathname) setValue(location.pathname)
  }, [location.pathname])

  return (
    <Container>
      {canShowApplications && (
      <NavigationItem
        label="Aplicações"
        href="/"
        value={value}
        icon={<Home fontSize="small" />}
        onClick={handleOnClick}
      />
      )}
      {canShowManualAnalysis && (
        <NavigationItem
          label="revisões manuais"
          href="/manual-analisys-audit"
          value={value}
          icon={<FindInPage fontSize="small" />}
          onClick={handleOnClick}
      />)}
      {canShowStatistics && (
        <NavigationItem
          label="Estatísticas"
          href="/statistics"
          value={value}
          icon={<Assessment fontSize="small" />}
          onClick={handleOnClick}
      />)}
      {canListUserActivity && (
        <NavigationItem
          label="Monitor de usuários"
          href="/user-activity"
          value={value}
          icon={<CoPresent fontSize="small" />}
          onClick={handleOnClick}
        />
      )}
      <NavigationItem label="Ajuda" href="" icon={<Help fontSize="small" />} onClick={() => setHelpModalOpen(true)} />
      <Modal open={helpModalOpen} onClose={() => setHelpModalOpen(false)} title="Dúvidas Comuns">
        <HelpDialog />
      </Modal>
    </Container>
  )
}

export default Navigation
